const TabTitle = ({ title, config }) => {
  return (
    <div className="flex items-center px-v3-sm pt-v3-md pb-v3-sm">
      <p
        className="font-bolder font-inter-variable text-v3-h5"
        style={{
          color: config?.element_color || 'var(--v3-black-dark)',
          fontFamily: config?.font_name ? `${config.font_name}, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif` : undefined,
          fontSize: config?.font_size ? `${config.font_size + 5}px` : undefined,
        }}
      >
        {title}
      </p>
    </div>
  );
};

export default TabTitle;